import "App.scss";
import LoadingAnimation from "components/LoadingAnimation/LoadingAnimation";
import Taskbar from "components/Taskbar/Taskbar";
import { AuthProvider } from "providers/AuthProvider";
import { PrivacyProvider } from 'providers/PrivacyProvider';
import { R2Provider } from "providers/R2Provider";
import { SnackbarProvider } from 'providers/SnackbarProvider';
import { Suspense, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import AppRoutes from './AppRoutes';

const App = () => {
	const location = useLocation();
	const [taskbarClassName, setTaskbarClassName] = useState('');

	// Modify appearance of components depending on page/location.
	useEffect(() => {
		if (location.pathname === '/auth') {
			setTaskbarClassName('taskbar--hidden');
		} else if (
			location.pathname === '/' ||
			location.pathname.includes('albums') ||
			location.pathname.includes('coin-flip') ||
			location.pathname.includes('dashboard') ||
			location.pathname.includes('flash-cards-game') ||
			location.pathname.includes('wallpapers/preview')
		) {
			setTaskbarClassName('taskbar--black-transparent')
		} else if (location.pathname.includes('timeline')) {
			setTaskbarClassName('taskbar--black-transparent taskbar--fixed');
		} else {
			setTaskbarClassName('')
		}
	}, [location]);

	return (
		<AuthProvider>
			<PrivacyProvider>
				<R2Provider>
					<SnackbarProvider>
						<div id='off-canvas-panel-hook'></div>
						<div id='modal-hook'></div>
						<div className='app'>
							<Taskbar className={taskbarClassName} />
							<div className='app__content-area'>
								<Suspense fallback={<LoadingAnimation asOverlay />}>
									<AppRoutes />
								</Suspense>
							</div>
						</div>
					</SnackbarProvider>
				</R2Provider>
			</PrivacyProvider>
		</AuthProvider>
	);
};

export default App;